// eslint-disable
// this is an auto generated file. This will be overwritten

export const getBet = `query GetBet($id: ID!) {
  getBet(id: $id) {
    id
    betPosition
    betType
    betValue
    chat_id
    created_at
    event_id
    handicap
    odds
    positionName
    ss
    status_id
    time_str
    resultValue
    eventName
  }
}
`;
export const listBets = `query ListBets($filter: ModelBetFilterInput, $limit: Int, $nextToken: String) {
  listBets(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      betPosition
      betType
      betValue
      chat_id
      created_at
      event_id
      handicap
      odds
      positionName
      ss
      status_id
      time_str
      resultValue
      eventName
    }
    nextToken
  }
}
`;
